'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dolphinNativeBridge = require('dolphin-native-bridge');

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _color2 = require('color');

var _color3 = _interopRequireDefault(_color2);

var _dofSpinner = require('../dof-spinner');

var _dofSpinner2 = _interopRequireDefault(_dofSpinner);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: { DofIconfont: _dofIconfont2.default, DofSpinner: _dofSpinner2.default, DiabloMixin: _diablo2.default },
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    // 是否激活态
    active: {
      type: Boolean,
      default: false
    },
    // 常态图片
    img: {
      type: String
    },
    // 常态背景颜色
    color: {
      type: String,
      default: ''
    },
    // 点击背景颜色
    activeColor: {
      type: String,
      default: ''
    },
    // 字体颜色
    textColor: {
      type: String,
      default: ''
    },
    // 点击未松手背景颜色
    touchColor: {
      type: String,
      default: ''
    },
    // 是否loading
    isLoading: {
      type: Boolean,
      default: false
    },
    // loading图片
    loadingImg: {
      type: String,
      default: 'black'
    },
    // 选中态图片
    activeImg: {
      type: String,
      default: ''
    },
    round: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    },
    // 是否展示三角
    isShowTriangle: {
      type: Boolean,
      default: false
    },
    // 常规边框颜色
    borderColor: {
      type: String,
      default: ''
    },
    // 选中态边框颜色
    activeBorderColor: {
      type: String,
      default: ''
    },
    // 是否开启震动反馈
    isHapticFeedback: {
      type: Boolean,
      default: false
    },
    // 按钮大小
    btnSize: {
      type: Number,
      default: 96
    },
    // 图片大小
    imgSize: {
      type: Number,
      default: 96
    },
    // loading图片大小
    loadingImgSize: {
      type: Number,
      default: 0
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 朴素按钮(暂时只支持colmo)
    isPlain: {
      type: Boolean,
      default: false
    },
    // 使用iconFont { code: '\uXXX', color: '' }
    iconFont: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 点击态iconFont { ode: '\uXXX', color: '' }
    activeIconFont: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  model: {
    prop: 'active',
    event: 'change'
  },
  computed: {
    // 常态背景颜色
    _color: function _color() {
      if (this.color) return this.color;
      if (this._isColmo) {
        return this.isPlain ? 'transparent' : '#2d2e2f';
      } else {
        return this._isDiablo ? '#45494C' : '#F6F7F9';
      }
    },

    // 点击背景颜色
    _activeColor: function _activeColor() {
      if (this.activeColor) return this.activeColor;
      if (this._isColmo) {
        return this.isPlain ? 'transparent' : '#b45336';
      } else {
        return this._isDiablo ? '#0490D3' : '#00A4F2';
      }
    },

    // 常规边框颜色
    _borderColor: function _borderColor() {
      if (this.borderColor) return this.borderColor;
      if (this._isColmo) {
        return this.isPlain ? '#6f7070' : 'transparent';
      } else {
        return 'transparent';
      }
    },

    // 选中态边框颜色
    _activeBorderColor: function _activeBorderColor() {
      if (this.activeBorderColor) return this.activeBorderColor;
      if (this._isColmo) {
        return this.isPlain ? '#b45336' : 'transparent';
      } else {
        return 'transparent';
      }
    },

    // 字体颜色
    _textColor: function _textColor() {
      if (this.textColor) return this.textColor;
      return this._isColmo ? 'rgb(204, 204, 204)' : this._isDiablo ? '#cfcfd0' : '#1E2E37';
    },

    // touch颜色
    _touchColor: function _touchColor() {
      if (this.touchColor) return this.touchColor;
      if (this._isColmo) {
        return this.isPlain ? '#2d2e2f' : this.active ? '#bc654a' : '#424344';
      } else {
        return '';
      }
    },

    // loading图片大小
    _loadingImgSize: function _loadingImgSize() {
      if (this.loadingImgSize) return this.loadingImgSize;
      return this._isColmo ? 48 : 32;
    },
    src: function src() {
      var res = this.active ? this.activeImg : this.img;
      return res || this.img;
    },
    loadingSrc: function loadingSrc() {
      if (this._isColmo) return 'colmo';
      var bgColor = this.style.backgroundColor;
      if (bgColor === 'transparent') return 'black';

      var color = new _color3.default(bgColor);
      return color.isDark() ? 'white' : 'black';
    },
    _iconFont: function _iconFont() {
      if (!this.iconFont.code) return {};
      var res = {};
      if (this.active) {
        res = this.activeIconFont.code ? this.activeIconFont : { code: this.iconFont.code, color: 'rgba(255,255,255,0.80)' };
      } else {
        res = this.iconFont;
      }
      // 颜色默认值
      if (!res.color) res.color = this.active ? 'rgba(255,255,255,0.80)' : this._isColmo ? 'rgba(255,255,255,0.40)' : '#666';
      return res;
    },
    maskStyle: function maskStyle() {
      // 右下角三角优先使用 borderColor 与 activeBorderColor
      var res = this._borderColor !== 'transparent' && this._activeBorderColor !== 'transparent' ? {
        backgroundColor: this.active ? this._activeBorderColor : this._borderColor
      } : {
        backgroundColor: this.active ? this._activeColor : this._color
      };
      !this.isLoading && this._touchColor && (res['backgroundColor:active'] = this._touchColor);
      return res;
    },
    style: function style() {
      var res = {
        backgroundColor: this.active ? this._activeColor : this._color,
        'border-width': '2px',
        'border-style': 'solid',
        'border-color': this.active ? this._activeBorderColor : this._borderColor,
        width: this.btnSize + 'px',
        height: this.btnSize + 'px',
        'border-radius': this.btnSize / 2 + 'px'
      };
      !this.isLoading && this._touchColor && (res['backgroundColor:active'] = this._touchColor);
      return res;
    },
    imgStyle: function imgStyle() {
      return {
        width: this.imgSize + 'px',
        height: this.imgSize + 'px',
        'border-radius': this.imgSize / 2 + 'px'
      };
    },
    loadingImgStyle: function loadingImgStyle() {
      return {
        width: this._loadingImgSize + 'px',
        height: this._loadingImgSize + 'px',
        'border-radius': this._loadingImgSize / 2 + 'px'
      };
    },
    isIp6: function isIp6() {
      if (weex && weex.config.env.osName === 'iOS') {
        var deviceModel = weex.config.env.deviceModel.substr(6); // 'iPhone10,3' ==> 10.3
        return deviceModel.split(',')[0] < 8 // > iphone7 以下
        ;
      } else {
        return false;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.disabled || this.isLoading) return;
      // 震动反馈
      if (this.isHapticFeedback) _dolphinNativeBridge.Bridge.hapticFeedback(!this.isIp6 ? 1 : null);
      this.$emit('change', !this.active);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-icon-button/index.vue
// module id = 340
// module chunks = 0 1